"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildSearchBreadcrumbs = exports.buildLocalityBreadcrumbs = exports.buildBreadcrumbs = void 0;
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _listingTypeBreadcrumbLabels = _interopRequireDefault(require("../enums/listing-type-breadcrumb-labels"));
var _listingTypeBrowseContext = _interopRequireDefault(require("../enums/listing-type-browse-context"));
var _localityType = _interopRequireDefault(require("../enums/locality-type"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var slugify = text => text.replace(/\W+/g, '-').toLowerCase();
var HOME = {
  text: 'Home',
  link: '/'
};
var buildRawBreadcrumbs = (urlResolver, list) => {
  var breadcrumb = (text, link) => _objectSpread({
    text
  }, link && {
    link: urlResolver(link)
  });
  return list.map(_ref => {
    var text = _ref.text,
      link = _ref.link;
    return breadcrumb(text, link);
  });
};
var buildBreadcrumbs = exports.buildBreadcrumbs = function buildBreadcrumbs(urlResolver) {
  for (var _len = arguments.length, list = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    list[_key - 1] = arguments[_key];
  }
  return buildRawBreadcrumbs(urlResolver, [HOME, ...list]);
};
var getDivisionCrumb = (listingType, division, state, noLink) => _objectSpread({
  text: division.name
}, noLink && {
  link: "/ah/".concat(state.toLowerCase(), "/") + "".concat(listingType.pageContext, "/").concat(slugify(division.name), "/12").concat(division.id, "10")
});
var getDistrictCrumb = function getDistrictCrumb(listingType, district) {
  for (var _len2 = arguments.length, parts = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    parts[_key2 - 2] = arguments[_key2];
  }
  return _objectSpread({
    text: district.name
  }, !(0, _isEmpty.default)(parts) && {
    link: "/".concat(listingType.urlContext, "/search?district=").concat(slugify(parts.join(' ')))
  });
};
var getBrowseCrumb = function getBrowseCrumb(listingType, label) {
  for (var _len3 = arguments.length, parts = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
    parts[_key3 - 2] = arguments[_key3];
  }
  return _objectSpread({
    text: label
  }, !(0, _isEmpty.default)(parts) && {
    link: "/".concat(_listingTypeBrowseContext.default[listingType.name], "/").concat(slugify(parts.join(' ')), "/")
  });
};
var buildLocaltyList = function buildLocaltyList(listingType, bypassCanberra, locality) {
  var _locality$metaData;
  var noLink = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var isSoldPage = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var state = (_locality$metaData = locality.metaData) === null || _locality$metaData === void 0 ? void 0 : _locality$metaData.state;
  if (!state) {
    return [];
  }
  var items = {};
  var iteration = locality;
  while (iteration && iteration.type) {
    items[iteration.type] = iteration;
    iteration = iteration.parent;
  }
  var crumbs = [];
  if (isSoldPage) {
    crumbs.push(...[{
      text: 'Sold',
      link: '/sold/search'
    }, getBrowseCrumb(listingType, state.toUpperCase(), state)]);
  } else {
    crumbs.push(getBrowseCrumb(listingType, "".concat(_listingTypeBreadcrumbLabels.default[listingType.name].browse, " (").concat(state.toUpperCase(), ")"), state));
  }
  var division = items[_localityType.default.DIVISION.type];
  var district = items[_localityType.default.DISTRICT.type];
  var region = items[_localityType.default.REGION.type];
  var isACT = state.toUpperCase() === 'ACT';
  if (region && !(isACT && bypassCanberra)) {
    if (isACT) {
      crumbs.push(getBrowseCrumb(listingType, region.name, state));
    } else {
      var regionNoLink = noLink && locality.type === _localityType.default.REGION.type;
      var parts = !regionNoLink && [region.name, state] || [];
      crumbs.push(getBrowseCrumb(listingType, region.name, ...parts));
    }
  }
  if (district) {
    var districtNoLink = noLink && locality.type === _localityType.default.DISTRICT.type;
    var _parts = !districtNoLink && (isACT ? [district.name, state] : [district.name, region.name, state]) || [];
    crumbs.push(getDistrictCrumb(listingType, district, ..._parts));
  }
  if (division) {
    var divisionNoLink = noLink && locality.type === _localityType.default.DIVISION.type;
    crumbs.push(getDivisionCrumb(listingType, division, state, divisionNoLink));
  }
  return crumbs;
};
var buildLocalityBreadcrumbs = exports.buildLocalityBreadcrumbs = function buildLocalityBreadcrumbs(urlResolver, listingType, bypassCanberra, locality) {
  var isSoldPage = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  for (var _len4 = arguments.length, additional = new Array(_len4 > 5 ? _len4 - 5 : 0), _key4 = 5; _key4 < _len4; _key4++) {
    additional[_key4 - 5] = arguments[_key4];
  }
  return locality ? buildBreadcrumbs(urlResolver, ...buildLocaltyList(listingType, bypassCanberra, locality, (0, _isEmpty.default)(additional), isSoldPage), ...additional) : buildBreadcrumbs(urlResolver, ...additional);
};
var buildSearchBreadcrumbs = (urlResolver, listingType, isSoldPage) => buildBreadcrumbs(urlResolver, {
  text: isSoldPage ? 'Sold' : _listingTypeBreadcrumbLabels.default[listingType.name].search
});
exports.buildSearchBreadcrumbs = buildSearchBreadcrumbs;